import { render } from "./AddMgmtModal.vue?vue&type=template&id=23df1fa2&scoped=true"
import script from "./AddMgmtModal.vue?vue&type=script&lang=js"
export * from "./AddMgmtModal.vue?vue&type=script&lang=js"

import "./AddMgmtModal.vue?vue&type=style&index=0&id=23df1fa2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23df1fa2"]])

export default __exports__